"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotFound;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFound() {
  return _react2.default.createElement(
    "div",
    { className: "container" },
    _react2.default.createElement(
      "h1",
      null,
      "Doh! 404!"
    ),
    _react2.default.createElement(
      "p",
      null,
      "These are ",
      _react2.default.createElement(
        "em",
        null,
        "not"
      ),
      " the droids you are looking for!"
    )
  );
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFound/NotFound.jsx
// module id = 1638
// module chunks = 0